import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import {
  COMMAND,
  LOCATION,
  TEXT,
  HISTORICAL_UTILIZATION_TYPES,
} from '../../../Constants/WidgetTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { STICKY_OVERRIDE } from '../../../Styles/Z-INDEX';
import { isTimeFilterVisible } from './utils';

export const TIME_RANGE_OPTIONS = [
  { label: 'custom', value: 'custom' },
  { label: '1 hr', value: 1 },
  { label: '3 hrs', value: 3 },
  { label: '8 hrs', value: 8 },
];

export default function TimeRangeDropdown(props) {
  const {
    timeFilter,
    dropdownItemClass,
    displayTextAsGrid,
    type,
    updateRealTime,
    toggleUtilizationTimeSelectModal,
    handleTimeRangeFilter,
    handleReturnToRealTime,
    forceDisplay,
  } = props;
  const timeFilterVisibility =
    forceDisplay || isTimeFilterVisible(type, displayTextAsGrid)
      ? 'visible'
      : 'd-none';
  const timeRangeOptions =
    type === LOCATION
      ? TIME_RANGE_OPTIONS.concat({
          label: '24 hrs',
          value: 24,
        })
      : TIME_RANGE_OPTIONS;
  return (
    <>
      <UncontrolledDropdown className={timeFilterVisibility}>
        <DropdownToggle color="link" className="p-0">
          <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
        </DropdownToggle>
        <DropdownMenu
          right
          className="rounded-lg shadow"
          style={{
            minWidth: '6rem',
            transform: 'translate3d(-5rem, 16px, 0px)',
            zIndex: STICKY_OVERRIDE,
          }}
        >
          {!updateRealTime ? (
            <DropdownItem
              className={dropdownItemClass}
              disabled={type === COMMAND}
              onClick={handleReturnToRealTime}
            >
              return to real time
            </DropdownItem>
          ) : null}
          {type === TEXT ? (
            <DropdownItem
              className={`${dropdownItemClass} ${
                timeFilter ? 'text-brand-primary' : ''
              }`}
              onClick={() => handleTimeRangeFilter('custom')}
            >
              view historical
            </DropdownItem>
          ) : (
            timeRangeOptions.map(({ label, value }, i) => (
              <DropdownItem
                className={`${dropdownItemClass} ${
                  value === timeFilter ? 'text-brand-primary' : ''
                }`}
                onClick={() => handleTimeRangeFilter(value)}
                key={i}
              >
                {label}
              </DropdownItem>
            ))
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
      <Button
        className={HISTORICAL_UTILIZATION_TYPES.has(type) ? 'p-0' : 'd-none'}
        color="link"
        onClick={toggleUtilizationTimeSelectModal}
      >
        <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
      </Button>
    </>
  );
}

TimeRangeDropdown.propTypes = {
  dropdownItemClass: PropTypes.string,
  timeFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  displayTextAsGrid: PropTypes.bool,
  type: PropTypes.string,
  updateRealTime: PropTypes.bool,
  forceDisplay: PropTypes.bool,
  toggleUtilizationTimeSelectModal: PropTypes.func,
  handleTimeRangeFilter: PropTypes.func,
  handleReturnToRealTime: PropTypes.func,
};
